// removed by extract-text-webpack-plugin
module.exports = {"container":"_2X9ksABckf5xjYtY_OkLnV","title":"_9tx_bDcOO1DHML-v5SRCj","changeLink":"j-lLFJ6qJbwbfA1x9t-Tw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/StatisticsInfoLine/StatisticsInfoLine.scss
// module id = 1329
// module chunks = 1